import React from 'react';

import { StatusChip } from '@@common';

import { FlowInstanceStatus } from '../../../api/api';

interface FlowInstanceStatusChipProps {
	status?: FlowInstanceStatus;
	size?: 'small' | 'medium';
}

export default function FlowInstanceStatusChip({ status, size = 'small' }: FlowInstanceStatusChipProps) {
	if (!status) return null;

	const statusColors: Record<FlowInstanceStatus, 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'> = {
		[FlowInstanceStatus.Completed]: 'success',
		[FlowInstanceStatus.Running]: 'info',
		[FlowInstanceStatus.Failed]: 'error',
		[FlowInstanceStatus.Waiting]: 'warning',
		[FlowInstanceStatus.Canceled]: 'default',
	};

	return (
		<StatusChip
			status={status}
			colorMap={statusColors}
			defaultColor="default"
			size={size}
			sx={{
				height: 20,
				fontSize: '0.65rem',
				'& .MuiChip-label': { px: 0.75 },
			}}
		/>
	);
}
